import { IAsidePanelEvents, IAsidePanelFields } from '../../components/AsidePanel/types';
import { AsidePanel } from '../../components/AsidePanel/AsidePanel';
import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../types/types';
import { IAsidePanelListViewSettingsHOCProps } from './types';
import { getAsidePanelIsMobile } from '../../store/selectors/getAsidePanelIsMobile';
import { onClose } from './events/onClose';
import { onResize } from '../AsidePanelHOC/events/onResize';
import { onResized } from '../AsidePanelHOC/events/onResized';
import { getMessages } from '../../../../../../store/constants';
import { getListViewSettingsBody } from './selectors/getListViewSettingsBody';

const mapStateToProps = (
    state: IApplicationState,
): IAsidePanelFields => {
    return {
        children: getListViewSettingsBody(),
        isMobile: getAsidePanelIsMobile(state),
        title: getMessages().getText('common.settings'),
    }
};

const mapDispatchToProps = (
    dispatch: any,
    ownProps: IAsidePanelListViewSettingsHOCProps
): IAsidePanelEvents => {
    return {
        onClose: () => dispatch(onClose()),
        onResize: (width) => dispatch(onResize(width)),
        onResized: (width) => dispatch(onResized(width))
    }
};

export const AsidePanelListViewSettingsHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(AsidePanel);

AsidePanelListViewSettingsHOC.displayName = 'AsidePanelListViewSettingsHOC';
